import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	emptyText?: string;
};

export const EmptyFieldText = ({ emptyText }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<EmptyValueStyleWrapper>
			{emptyText ?? formatMessage(messages.emptyFieldText)}
		</EmptyValueStyleWrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const EmptyValueStyleWrapper = styled.span({
	color: token('color.text.subtlest'),
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	maxWidth: '100%',
});
